/**
 * @generated SignedSource<<82e4a9bfc0305e11ece1b5e9e15447fd>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type potentialAnalysis_Query$variables = {
  id: string;
};
export type potentialAnalysis_Query$data = {
  readonly PotentialAnalysis: {
    readonly LearnPotentialAnalysis: {
      readonly id: string;
      readonly isFinished: boolean;
      readonly modules: ReadonlyArray<{
        readonly " $fragmentSpreads": FragmentRefs<"moduleSection_PotentialAnalysisModuleFragment">;
      }>;
      readonly " $fragmentSpreads": FragmentRefs<"potentialAnalysisNavigation_PotentialAnalysisLearnPotentialAnalysisFragment">;
    } | null;
  };
  readonly Viewer: {
    readonly Auth: {
      readonly " $fragmentSpreads": FragmentRefs<"avatarWithProfileMenu_AuthViewerSchemaFragment">;
    };
  };
};
export type potentialAnalysis_Query = {
  response: potentialAnalysis_Query$data;
  variables: potentialAnalysis_Query$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "learnPotentialAnalysisId",
    "variableName": "id"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isFinished",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "kind",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "answerOptionId",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "text",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "concreteType": "PotentialAnalysisSelectAnswerOption",
  "kind": "LinkedField",
  "name": "answerOptions",
  "plural": true,
  "selections": [
    (v6/*: any*/),
    (v7/*: any*/)
  ],
  "storageKey": null
},
v9 = [
  (v5/*: any*/),
  (v6/*: any*/)
],
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "questionText",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "concreteType": "PotentialAnalysisFreetextAnswerOption",
  "kind": "LinkedField",
  "name": "answerOptions",
  "plural": true,
  "selections": [
    (v6/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isFreeText",
      "storageKey": null
    },
    (v7/*: any*/)
  ],
  "storageKey": null
},
v12 = [
  (v5/*: any*/),
  (v6/*: any*/),
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "freeText",
    "storageKey": null
  }
],
v13 = [
  (v8/*: any*/),
  {
    "alias": null,
    "args": null,
    "concreteType": "PotentialAnalysisSelectedGivenAnswer",
    "kind": "LinkedField",
    "name": "givenAnswer",
    "plural": false,
    "selections": (v9/*: any*/),
    "storageKey": null
  },
  (v10/*: any*/)
],
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "potentialAnalysis_Query",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "PotentialAnalysisQueries",
        "kind": "LinkedField",
        "name": "PotentialAnalysis",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": (v1/*: any*/),
            "concreteType": "PotentialAnalysis_LearnPotentialAnalysis",
            "kind": "LinkedField",
            "name": "LearnPotentialAnalysis",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "PotentialAnalysis_Module",
                "kind": "LinkedField",
                "name": "modules",
                "plural": true,
                "selections": [
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "moduleSection_PotentialAnalysisModuleFragment"
                  }
                ],
                "storageKey": null
              },
              (v3/*: any*/),
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "potentialAnalysisNavigation_PotentialAnalysisLearnPotentialAnalysisFragment"
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "ViewerQueryType",
        "kind": "LinkedField",
        "name": "Viewer",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "AuthViewerSchema",
            "kind": "LinkedField",
            "name": "Auth",
            "plural": false,
            "selections": [
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "avatarWithProfileMenu_AuthViewerSchemaFragment"
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "potentialAnalysis_Query",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "PotentialAnalysisQueries",
        "kind": "LinkedField",
        "name": "PotentialAnalysis",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": (v1/*: any*/),
            "concreteType": "PotentialAnalysis_LearnPotentialAnalysis",
            "kind": "LinkedField",
            "name": "LearnPotentialAnalysis",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "PotentialAnalysis_Module",
                "kind": "LinkedField",
                "name": "modules",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "PotentialAnalysis_Dimension",
                    "kind": "LinkedField",
                    "name": "dimensions",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "dimensionId",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "dimensionText",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": null,
                        "kind": "LinkedField",
                        "name": "questions",
                        "plural": true,
                        "selections": [
                          (v4/*: any*/),
                          (v2/*: any*/),
                          (v5/*: any*/),
                          {
                            "kind": "TypeDiscriminator",
                            "abstractKey": "__isPotentialAnalysisQuestion"
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v8/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "PotentialAnalysisSelectedGivenAnswer",
                                "kind": "LinkedField",
                                "name": "givenAnswers",
                                "plural": true,
                                "selections": (v9/*: any*/),
                                "storageKey": null
                              },
                              (v10/*: any*/)
                            ],
                            "type": "PotentialAnalysisMultipleChoiceQuestion",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v11/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "PotentialAnalysisSelectedWithFreetextGivenAnswer",
                                "kind": "LinkedField",
                                "name": "givenAnswers",
                                "plural": true,
                                "selections": (v12/*: any*/),
                                "storageKey": null
                              },
                              (v10/*: any*/)
                            ],
                            "type": "PotentialAnalysisMultipleChoiceFreetextQuestion",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": (v13/*: any*/),
                            "type": "PotentialAnalysisSingleChoiceQuestion",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v11/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "PotentialAnalysisSelectedWithFreetextGivenAnswer",
                                "kind": "LinkedField",
                                "name": "givenAnswer",
                                "plural": false,
                                "selections": (v12/*: any*/),
                                "storageKey": null
                              },
                              (v10/*: any*/)
                            ],
                            "type": "PotentialAnalysisSingleChoiceFreetextQuestion",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": (v13/*: any*/),
                            "type": "PotentialAnalysisScaleQuestion",
                            "abstractKey": null
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "PotentialAnalysisTextGivenAnswer",
                                "kind": "LinkedField",
                                "name": "givenAnswer",
                                "plural": false,
                                "selections": [
                                  (v5/*: any*/),
                                  (v7/*: any*/)
                                ],
                                "storageKey": null
                              },
                              (v10/*: any*/)
                            ],
                            "type": "PotentialAnalysisTextQuestion",
                            "abstractKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "moduleId",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "moduleText",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              (v3/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "ViewerQueryType",
        "kind": "LinkedField",
        "name": "Viewer",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "AuthViewerSchema",
            "kind": "LinkedField",
            "name": "Auth",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "CurrentUser",
                "kind": "LinkedField",
                "name": "currentUser",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "User",
                    "kind": "LinkedField",
                    "name": "user",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": [
                          {
                            "kind": "Literal",
                            "name": "userExtensionKind",
                            "value": "Academies"
                          }
                        ],
                        "concreteType": null,
                        "kind": "LinkedField",
                        "name": "extension",
                        "plural": false,
                        "selections": [
                          (v4/*: any*/),
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "firstName",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "lastName",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "File",
                                "kind": "LinkedField",
                                "name": "avatar",
                                "plural": false,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "thumbnail",
                                    "storageKey": null
                                  },
                                  (v2/*: any*/)
                                ],
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "sumGamificationPoints",
                                "storageKey": null
                              }
                            ],
                            "type": "AcademiesUserExtension",
                            "abstractKey": null
                          }
                        ],
                        "storageKey": "extension(userExtensionKind:\"Academies\")"
                      },
                      (v2/*: any*/),
                      (v14/*: any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Account",
                    "kind": "LinkedField",
                    "name": "accounts",
                    "plural": true,
                    "selections": [
                      (v2/*: any*/),
                      (v14/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "6ae607330945c00fb15dec72936a6a68",
    "id": null,
    "metadata": {},
    "name": "potentialAnalysis_Query",
    "operationKind": "query",
    "text": "query potentialAnalysis_Query(\n  $id: ID!\n) {\n  PotentialAnalysis {\n    LearnPotentialAnalysis(learnPotentialAnalysisId: $id) {\n      id\n      modules {\n        ...moduleSection_PotentialAnalysisModuleFragment\n      }\n      isFinished\n      ...potentialAnalysisNavigation_PotentialAnalysisLearnPotentialAnalysisFragment\n    }\n  }\n  Viewer {\n    Auth {\n      ...avatarWithProfileMenu_AuthViewerSchemaFragment\n    }\n  }\n}\n\nfragment accountSwitchMenu_AuthViewerSchemaFragment on AuthViewerSchema {\n  currentUser {\n    user {\n      ...userAvatar_UserFragment\n      name\n      id\n    }\n    accounts {\n      id\n      name\n    }\n  }\n}\n\nfragment avatarWithProfileMenu_AuthViewerSchemaFragment on AuthViewerSchema {\n  currentUser {\n    user {\n      ...userAvatar_UserFragment\n      id\n    }\n  }\n  ...accountSwitchMenu_AuthViewerSchemaFragment\n}\n\nfragment checkboxQuestion_PotentialAnalysisQuestionFragment on PotentialAnalysisQuestion {\n  __isPotentialAnalysisQuestion: __typename\n  kind\n  id\n  ... on PotentialAnalysisMultipleChoiceFreetextQuestion {\n    questionText\n    answerOptions {\n      answerOptionId\n      isFreeText\n      text\n    }\n    givenAnswers {\n      answerOptionId\n      freeText\n      kind\n    }\n  }\n  ... on PotentialAnalysisMultipleChoiceQuestion {\n    questionText\n    answerOptions {\n      answerOptionId\n      text\n    }\n    givenAnswers {\n      answerOptionId\n      kind\n    }\n  }\n  ... on PotentialAnalysisSingleChoiceFreetextQuestion {\n    questionText\n    answerOptions {\n      answerOptionId\n      isFreeText\n      text\n    }\n    givenAnswer {\n      answerOptionId\n      freeText\n      kind\n    }\n  }\n  ... on PotentialAnalysisSingleChoiceQuestion {\n    kind\n    questionText\n    answerOptions {\n      answerOptionId\n      text\n    }\n    givenAnswer {\n      answerOptionId\n      kind\n    }\n  }\n}\n\nfragment dimensionSection_PotentialAnalysisDimensionFragment on PotentialAnalysis_Dimension {\n  dimensionId\n  dimensionText\n  questions {\n    __typename\n    id\n    kind\n    ... on PotentialAnalysisMultipleChoiceQuestion {\n      answerOptions {\n        answerOptionId\n      }\n      givenAnswers {\n        kind\n        answerOptionId\n      }\n    }\n    ... on PotentialAnalysisMultipleChoiceFreetextQuestion {\n      answerOptions {\n        answerOptionId\n        isFreeText\n      }\n      givenAnswers {\n        kind\n        answerOptionId\n        freeText\n      }\n    }\n    ... on PotentialAnalysisSingleChoiceQuestion {\n      answerOptions {\n        answerOptionId\n      }\n      givenAnswer {\n        kind\n        answerOptionId\n      }\n    }\n    ... on PotentialAnalysisSingleChoiceFreetextQuestion {\n      answerOptions {\n        answerOptionId\n        isFreeText\n      }\n      givenAnswer {\n        kind\n        answerOptionId\n        freeText\n      }\n    }\n    ... on PotentialAnalysisScaleQuestion {\n      answerOptions {\n        answerOptionId\n      }\n      givenAnswer {\n        kind\n        answerOptionId\n      }\n    }\n    ... on PotentialAnalysisTextQuestion {\n      givenAnswer {\n        kind\n        text\n      }\n    }\n    ...questionSection_PotentialAnalysisQuestionFragment\n  }\n}\n\nfragment moduleSection_PotentialAnalysisModuleFragment on PotentialAnalysis_Module {\n  dimensions {\n    dimensionId\n    ...dimensionSection_PotentialAnalysisDimensionFragment\n  }\n  moduleId\n  moduleText\n}\n\nfragment potentialAnalysisNavigation_PotentialAnalysisLearnPotentialAnalysisFragment on PotentialAnalysis_LearnPotentialAnalysis {\n  modules {\n    dimensions {\n      dimensionId\n      questions {\n        __typename\n        id\n        kind\n        ... on PotentialAnalysisMultipleChoiceQuestion {\n          answerOptions {\n            answerOptionId\n          }\n          givenAnswers {\n            kind\n            answerOptionId\n          }\n        }\n        ... on PotentialAnalysisMultipleChoiceFreetextQuestion {\n          answerOptions {\n            answerOptionId\n            isFreeText\n          }\n          givenAnswers {\n            kind\n            answerOptionId\n            freeText\n          }\n        }\n        ... on PotentialAnalysisSingleChoiceQuestion {\n          answerOptions {\n            answerOptionId\n          }\n          givenAnswer {\n            kind\n            answerOptionId\n          }\n        }\n        ... on PotentialAnalysisSingleChoiceFreetextQuestion {\n          answerOptions {\n            answerOptionId\n            isFreeText\n          }\n          givenAnswer {\n            kind\n            answerOptionId\n            freeText\n          }\n        }\n        ... on PotentialAnalysisScaleQuestion {\n          answerOptions {\n            answerOptionId\n          }\n          givenAnswer {\n            kind\n            answerOptionId\n          }\n        }\n        ... on PotentialAnalysisTextQuestion {\n          givenAnswer {\n            kind\n            text\n          }\n        }\n      }\n    }\n  }\n}\n\nfragment questionSection_PotentialAnalysisQuestionFragment on PotentialAnalysisQuestion {\n  __isPotentialAnalysisQuestion: __typename\n  kind\n  id\n  ... on PotentialAnalysisMultipleChoiceQuestion {\n    questionText\n    answerOptions {\n      answerOptionId\n    }\n    givenAnswers {\n      kind\n      answerOptionId\n    }\n  }\n  ... on PotentialAnalysisMultipleChoiceFreetextQuestion {\n    questionText\n    answerOptions {\n      answerOptionId\n      isFreeText\n    }\n    givenAnswers {\n      kind\n      answerOptionId\n      freeText\n    }\n  }\n  ... on PotentialAnalysisSingleChoiceQuestion {\n    questionText\n    answerOptions {\n      answerOptionId\n    }\n    givenAnswer {\n      kind\n      answerOptionId\n    }\n  }\n  ... on PotentialAnalysisSingleChoiceFreetextQuestion {\n    questionText\n    answerOptions {\n      answerOptionId\n      isFreeText\n    }\n    givenAnswer {\n      kind\n      answerOptionId\n      freeText\n    }\n  }\n  ... on PotentialAnalysisScaleQuestion {\n    questionText\n    answerOptions {\n      answerOptionId\n    }\n    givenAnswer {\n      kind\n      answerOptionId\n    }\n  }\n  ... on PotentialAnalysisTextQuestion {\n    questionText\n    givenAnswer {\n      kind\n      text\n    }\n  }\n  ...checkboxQuestion_PotentialAnalysisQuestionFragment\n  ...textQuestion_PotentialAnalysisQuestionFragment\n  ...scaleQuestion_PotentialAnalysisQuestionFragment\n}\n\nfragment scaleQuestion_PotentialAnalysisQuestionFragment on PotentialAnalysisQuestion {\n  __isPotentialAnalysisQuestion: __typename\n  kind\n  id\n  ... on PotentialAnalysisScaleQuestion {\n    questionText\n    id\n    givenAnswer {\n      kind\n      answerOptionId\n    }\n    answerOptions {\n      answerOptionId\n      text\n    }\n  }\n}\n\nfragment textQuestion_PotentialAnalysisQuestionFragment on PotentialAnalysisQuestion {\n  __isPotentialAnalysisQuestion: __typename\n  kind\n  id\n  ... on PotentialAnalysisTextQuestion {\n    questionText\n    kind\n    givenAnswer {\n      text\n      kind\n    }\n  }\n}\n\nfragment userAvatar_UserFragment on User {\n  extension(userExtensionKind: Academies) {\n    __typename\n    ... on AcademiesUserExtension {\n      firstName\n      lastName\n      avatar {\n        thumbnail\n        id\n      }\n      sumGamificationPoints\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "fe7eb3b357717af79a39bdee83df05bb";

export default node;
